import {createPinia, defineStore} from "pinia";
import {init} from "./init";
import {getters} from "./getters";
import {actions} from "./actions";
import {init as gameInit} from "./game/init";
import {actions as gameActions} from "./game/actions";

export const useMainStore = defineStore('main', {
    state: () => Object.assign({}, init),
    getters,
    actions,
});

export const useGameStore = defineStore('game', {
    state: () => Object.assign({}, gameInit),
    actions: gameActions,
});

const pinia = createPinia();
export default pinia;
